var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPowerBy = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 25C8.43548 25 4 20.6 4 15.2571C4 11.3286 6.33871 7.87143 10.0484 6.3C10.371 6.14286 10.8548 6.3 11.0161 6.69286C11.1774 7.00714 11.0161 7.47857 10.6129 7.63571C7.46774 8.97143 5.45161 11.9571 5.45161 15.3357C5.45161 19.9714 9.32258 23.7429 14.0806 23.7429C18.8387 23.7429 22.7097 19.9714 22.7097 15.3357C22.7097 11.9571 20.6935 8.97143 17.5484 7.63571C17.2258 7.47857 17.0645 7.08571 17.1452 6.69286C17.2258 6.3 17.629 6.14286 17.9516 6.3C21.6613 7.87143 24 11.3286 24 15.2571C24 20.6 19.5645 25 14 25Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 12.8214C13.5969 12.8214 13.2743 12.5071 13.2743 12.1143V3.70714C13.2743 3.31429 13.5969 3 14.0001 3C14.4033 3 14.7259 3.31429 14.7259 3.70714V12.1929C14.7259 12.5071 14.4033 12.8214 14.0001 12.8214Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPowerBy, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/power-by.747d0425.svg";
export { ForwardRef as ReactComponent };